import Logo from '../Logo.js'
import Menu from './Components/Menu.js'

function Header() {
  return (
    <div className="row">
      <div className="col-6"><Logo /></div>
      <div className="col-6"><Menu /></div>
    </div>
  )
}

export default Header
